// The Parts tree's item filter values and default (F-0334, PT-32), import-free: the sidebar's links read them
// at launch, and `partItemFilters.ts` (the view engine's part queries) must stay out of the web entry (T-0770).

/** "Not done": every status that is not done — the tree's default, as its counts always were. */
export const NOT_DONE = '';
/** Any status, done ones too. */
export const ANY_STATUS = '__any__';
/** Anyone, or any release: no narrowing. */
export const ANY = '';
/** Nobody responsible, or no target release. */
export const NONE = '__none__';

export interface IPartItemFilter {
  /** {@link NOT_DONE}, {@link ANY_STATUS}, or a status key (`featit list --state <key>`). */
  status: string;
  /** {@link ANY}, {@link NONE}, or a responsible key (`featit list --responsible`). */
  responsible: string;
  /** {@link ANY}, {@link NONE}, or a target release id (`featit list --target-release-prefix`). */
  release: string;
}

export const DEFAULT_PART_ITEM_FILTER: IPartItemFilter = {
  status: NOT_DONE,
  responsible: ANY,
  release: ANY,
};
